export default __webpack_public_path__ + "static/media/logo_colored.856905de.png";